<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>

        <!-- Vista con área forzada (Carlos/Gerardo con ?area=callcenter o ?area=sistemas) -->
        <template v-if="areaForzada !== null">
          <Tickets :key="'area-' + areaForzada" :forzar-area="areaForzada" />
        </template>

        <!-- Vista normal para todos los demás -->
        <template v-else>
          <Tickets 
            v-if="selectedFilter === 'tickets'" 
            @change-view="handleViewChange"
          />
          <Pendientes 
            v-if="selectedFilter === 'pendientes'" 
            @change-view="handleViewChange"
          />
          <Asignados 
            v-if="selectedFilter === 'asignados'" 
            @change-view="handleViewChange"
          />
          <Suspendidos 
            v-if="selectedFilter === 'suspendidos'" 
            @change-view="handleViewChange"
          />
          <Cerrados 
            v-if="selectedFilter === 'cerrados'" 
            @change-view="handleViewChange"
          />
        </template>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Pendientes from './Pendientes.vue'
import Asignados from './Asignados.vue'
import Suspendidos from './Suspendidos.vue'
import Cerrados from './Cerrados.vue'
import Tickets from './Tickets.vue'

export default {
  name: 'Todos',
  components: {
    Pendientes,
    Asignados,
    Suspendidos,
    Cerrados,
    Tickets,
  },
  data() {
    return {
      selectedFilter: 'pendientes',
    }
  },
  computed: {
    areaForzada() {
      const area = this.$route && this.$route.query && this.$route.query.area;
      if (area === 'callcenter') return 1;
      if (area === 'sistemas') return 2;
      return null;
    },
  },
  methods: {
    handleViewChange(newView) {
      this.selectedFilter = newView;
    },
  },
}
</script>

<style scoped>
</style>
